import { useState, useEffect, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomButton from 'components/common/CustomButton';
import { ISignUpComponents, ISignUpInfo } from 'types/signup';
import First from 'components/login/SignUp/First';
import Second from 'components/login/SignUp/Second';
import Third from 'components/login/SignUp/Third';
import Fourth from 'components/login/SignUp/Fourth';
import PageTemplate from 'components/template/PageTemplate';
import axios from 'axios';
import { toast } from 'react-toastify';
import usePreventRefresh from 'hook/usePreventRefresh';
import { flushSync } from 'react-dom';
import { sendTeamRoom } from 'components/nateon';
import { getKoreaDateTime } from 'components/function';

const SignUp = () => {
    const navigate = useNavigate();
    const [tab, setTab] = useState<number>(1);

    // 회원가입 정보 추가예정
    const [signUpInfo, setSignUpInfo] = useState<ISignUpInfo>({} as ISignUpInfo);
    const [clear, setClear] = useState<boolean>(false);
    const [once, setOnce] = useState<boolean>(false);

    usePreventRefresh()
    const goPrev = () => {
        if (tab === 1) {
            navigate(-1)
        }
        else {
            setTab(t => t - 1)
        }
    }

    useEffect(() => {
        setClear(false)
    }, [tab])

    const goNext = async () => {
        if (tab === 4) {
            navigate('/login', { replace: true });
        }
        else if (tab === 3) {
            flushSync(() => {
                setOnce(true)
            })
            const reqData = {
                username: signUpInfo.username,
                password: signUpInfo.password,
                companyNameKr: signUpInfo.companyNameKr,
                companyNameEn: signUpInfo.companyNameEn,
                establishedAt: signUpInfo.establishedAt && signUpInfo.establishedAt,
                layer: signUpInfo.layer,
                bizNumberUser: signUpInfo.bizNumberUser,
                ceoName: signUpInfo.ceoName,
                phoneNumber: signUpInfo.phoneNumber,
                regionCode: signUpInfo.regionCode,
                agreeMarketing: signUpInfo.termsAgree[2],
            }

            // 회원가입 api 호출
            postSignup(reqData).then(res => {
                if (res.data.code === 200) {
                    toast.success(res.data.message)
                    setSignUpInfo({} as ISignUpInfo)
                    setTab(t => t + 1)
                    // 네이트온
                    sendTeamRoom('signup', `✨ Pulse On Ship 신규회원가입 🎉\n
회원가입일시: ${getKoreaDateTime()}
유저: ${signUpInfo.username}
회사이름: ${signUpInfo.companyNameKr}
대표자명: ${signUpInfo.ceoName}
사업자번호: ${signUpInfo.bizNumberUser}`)
                }
                else if (res.data.code === 400) {
                    toast.error('이미 존재하는 이메일입니다.')
                }
                else if (res.data.code === 401) {
                    toast.error('이미 존재하는 사업자 등롭 번호입니다.')
                }
            }).finally(() => {
                setOnce(false)
            })
        }
        else {
            setTab(t => t + 1)
        }
    }

    const postSignup = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL}signup`
        return await axios.post(url, reqData)
    }

    const components: Record<number, FC<ISignUpComponents>> = {
        1: First,
        2: Second,
        3: Third,
        4: Fourth,
    };

    const CurrentComponent = components[tab];

    return (
        <PageTemplate background='bg-[#f8f8f8]' isFooter={false}>
            <div className='flex flex-col justify-center items-center gap-4 py-30 mobile:py-4 min-h-dvh'>
                <div className={`flex flex-col justify-between transition-all bg-white h-[880px] p-10 rounded-3xl ${tab === 3 ? 'w-[1160px]' : 'w-[600px]'}  mobile:w-9/10 mobile:px-6 mobile:py-10 mobile:h-full mobile:transition-none`}>
                    <div>
                        <p className='mb-10 font-semibold text-32 mobile:text-2xl text-center'>회원가입</p>

                        <form className='min-w-[400px] mobile:min-w-full'>
                            <CurrentComponent
                                signUpInfo={signUpInfo}
                                setSignUpInfo={setSignUpInfo}
                                setClear={setClear}
                            />
                        </form>
                    </div>

                    <div className='flex justify-between gap-4'>
                        {
                            (tab !== 4) &&
                            <CustomButton
                                title='이전'
                                className='bg-red w-[200px] h-15 mobile:h-10'
                                onClick={goPrev}
                            />
                        }
                        {
                            (tab === 4 && once) ?
                                <CustomButton
                                    disabled
                                    className='bg-primary w-[200px] h-15 mobile:h-10'
                                    title={`회원가입중...`}
                                    onClick={() => { }}
                                /> :
                                <CustomButton
                                    disabled={tab === 4 ? false : !clear}
                                    className='bg-primary w-[200px] h-15 mobile:h-10'
                                    title={`${tab === 4 ? '로그인' : '다음'}`}
                                    onClick={goNext}
                                />
                        }
                    </div>
                </div>
            </div>

        </PageTemplate>
    );
}

export default SignUp;